<!-- ------------------------------------------------------------------------ TEMPLATE START -------------- -->
<template>
  <div>
    <LanguageComponent></LanguageComponent>

    <div class="container">
      <div class="row mt-5">
        <div v-for="error in $root.globalErrors" :key="error" class="col-sm-12">
          <div class="alert alert-danger">{{ error }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- ------------------------------------------------------------------------ TEMPLATE END ---------------- -->

<script>
import LanguageComponent from "@/components/LanguageComponent"

export default {
  name: "Forbidden",
  components: {
    LanguageComponent,
  },
  data() {
    return {}
  },
  mounted() {
    let root = this.$root
    root.appLoaded = true
  },
  methods: {},
}
</script>
<!-- ------------------------------------------------------------------------ SCRIPT START ---------------- -->
<!-- ------------------------------------------------------------------------ SCRIPT END ------------------ -->

<!-- ------------------------------------------------------------------------ STYLES START ---------------- -->
<style lang="scss" scoped></style>
<!-- ------------------------------------------------------------------------ STYLES END ------------------ -->
